import { CADASTRO_MENU_ROUTES } from 'app/pages/rf/cadastro/config/cadastro-menu-routes.config';
import { RouteInfo } from './vertical-menu.metadata';
import { ADMINISTRATIVO_MENU_ROUTES } from 'app/pages/rf/administrativo/config/administrativo-menu-routes.config';
import { CADASTRO_USUARIO_GRUPO_MENU_ROUTES } from 'app/pages/rf/cadastro-usuario-grupo/config/cadastro-usuario-grupo-menu-routes.config';
import { CADASTRO_USUARIO_PLAYER_MENU_ROUTES } from 'app/pages/rf/cadastro-usuario-player/config/cadastro-usuario-player-menu-routes.config';

//Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [
  ...CADASTRO_MENU_ROUTES,
  ...CADASTRO_USUARIO_GRUPO_MENU_ROUTES,
  ...CADASTRO_USUARIO_PLAYER_MENU_ROUTES,
  ADMINISTRATIVO_MENU_ROUTES
];
